import { FC, useEffect, useRef } from "react";
import SparklineLib from "sparklines";

interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  lineColor?: string;
  lineWidth?: number;
  className?: string;
  fillBelow?: boolean;
  fillLighten?: number;
}

export const Sparkline: FC<SparklineProps> = ({
  data,
  width,
  height = 20,
  lineColor = "#2563eb",
  lineWidth = 1.5,
  className,
  fillBelow = true,
  fillLighten = 0.5,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const sparklineRef = useRef<SparklineLib | null>(null);

  useEffect(() => {
    if (!containerRef.current || data.length === 0) return;

    const container = containerRef.current;

    const canvas = document.createElement("canvas");
    if (!canvas.getContext("2d")) {
      return;
    }

    const computedWidth = width ?? (container.clientWidth || 100);

    sparklineRef.current = new SparklineLib(container, {
      width: computedWidth,
      height,
      lineColor,
      lineWidth,
      fillBelow,
      fillLighten,
      startColor: "transparent",
      endColor: "transparent",
      maxColor: "transparent",
      minColor: "transparent",
    });

    sparklineRef.current.draw(data);

    return () => {
      container.innerHTML = "";
      sparklineRef.current = null;
    };
  }, [data, width, height, lineColor, lineWidth, fillBelow, fillLighten]);

  return (
    <div ref={containerRef} className={`block w-full ${className ?? ""}`} />
  );
};
